export default "__VITE_ASSET__Bq4$Uu5e__"